import {createContext} from 'react';

import type {ContextMenuContextType} from '../utils/types';

export const ContextMenuContext = createContext<ContextMenuContextType | null>(null);
